export default {"src":"/_next/static/media/icon-google-play.40ca38d8.svg","height":35,"width":108,"blurWidth":0,"blurHeight":0};